import { useContext } from 'react';
import { DocumentViewerApiSettingsContext } from "../context/api-settings.js";
export const useDocumentViewerApi = () => useContext(DocumentViewerApiSettingsContext);
//# sourceMappingURL=use-document-viewer-api.js.map